import { inboundShipmentIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";
import { InboundShipmentFileSchema_ } from "./get-shipment";

export const addShipmentFile = {
  name: "addShipmentFile" as const,
  input: z.object({
    shipmentId: inboundShipmentIdFormat.schema,
    title: z.string(),
  }),
  output: z.object({ file: InboundShipmentFileSchema_ }),
};
